import * as React from "react";
import { Typography } from "@material-ui/core";

const PageHeader = ({ portfolio }) => {
  return (
    <section className="page-header">
      {/* CYTH-1001 - The "Draft" watermark has been eliminated from the entire app, retaining this component as a placeholder for a future draft variant. */}
      {portfolio.onboardStatus === "in-review" && (
        <Typography variant={"h4"} style={{ opacity: 0.6 }}>
          Draft
        </Typography>
      )}
    </section>
  );
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/PageHeader.jsx